import { TranslateModule } from '@ngx-translate/core';
import { Component } from '@angular/core';

@Component({
  selector: 'wo-monthly-nth-recurrence',
  templateUrl: './monthly-nth-recurrence.component.html',
  standalone: true,
  imports: [ TranslateModule ],
})
export class MonthlyNthRecurrenceComponent {}
